import { render, staticRenderFns } from "./ReleaseNotesIssue.vue?vue&type=template&id=99307cf6&"
import script from "./ReleaseNotesIssue.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports